export enum ReportingScope {
    Default = 'Default',
    GreenConnect = 'GreenConnect'
}
